import { FC } from 'react';
import { DataObjectDirectoryView, DataObjectView } from '@atlas-frontend/sdk';

export const DataObjectDirectory: FC<{
  title: string | null;
  view: DataObjectView;
  getRedirectAnchor: (versionId: number, value: string) => React.ReactNode;
  onClickCreate: () => void;
  onSelectVersion: (params: { id?: number }) => void;
}> = (props) => {
  const { title, view, getRedirectAnchor, onClickCreate, onSelectVersion } =
    props;

  return (
    <DataObjectDirectoryView
      title={title}
      dataObjectView={view}
      getRedirectAnchor={getRedirectAnchor}
      onClickCreate={onClickCreate}
      onSelectVersion={onSelectVersion}
    />
  );
};
